import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SearchDriverHistoryEntity } from '../../domain/entities/SearchDriverHistoryEntity'
import type { SearchDriverByOrderIdAdminDto } from '@/backend/market'

export class SearchDriverHistoryModel extends SearchDriverHistoryEntity {
  constructor(dataDto: SearchDriverByOrderIdAdminDto) {
    super()
    mapEntityProperties<SearchDriverHistoryEntity>(this, dataDto)
  }
}
